export const wisconsinCountiesList = [
    'Adams',
    'Ashland',
    'Barron',
    'Bayfield',
    'Brown',
    'Buffalo',
    'Burnett',
    'Calumet',
    'Chippewa',
    'Clark',
    'Columbia',
    'Crawford',
    'Dane',
    'Dodge',
    'Door',
    'Douglas',
    'Dunn',
    'Eau Claire',
    'Florence',
    'Fond Du Lac',
    'Forest',
    'Grant',
    'Green',
    'Green Lake',
    'Iowa',
    'Iron',
    'Jackson',
    'Jefferson',
    'Juneau',
    'Kenosha',
    'Kewaunee',
    'La Crosse',
    'Lafayette',
    'Langlade',
    'Lincoln',
    'Manitowoc',
    'Marathon',
    'Marinette',
    'Marquette',
    'Menominee',
    'Milwaukee',
    'Monroe',
    'Oconto',
    'Oneida',
    'Outagamie',
    'Ozaukee',
    'Pepin',
    'Pierce',
    'Polk',
    'Portage',
    'Price',
    'Racine',
    'Richland',
    'Rock',
    'Rusk',
    'St. Croix',
    'Sauk',
    'Sawyer',
    'Shawano',
    'Sheboygan',
    'Taylor',
    'Trempealeau',
    'Vernon',
    'Vilas',
    'Walworth',
    'Washburn',
    'Washington',
    'Waukesha',
    'Waupaca',
    'Waushara',
    'Winnebago',
    'Wood',
    ]